var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3002 8.93L9.88024 6.5H15.5002V10H17.0002V5H9.88024L12.3002 2.57L11.2402 1.5L7.00024 5.75L11.2402 10L12.3002 8.93ZM12.0002 14C11.4069 14 10.8269 14.1759 10.3335 14.5056C9.84019 14.8352 9.45567 15.3038 9.22861 15.8519C9.00154 16.4001 8.94213 17.0033 9.05789 17.5853C9.17364 18.1672 9.45937 18.7018 9.87892 19.1213C10.2985 19.5409 10.833 19.8266 11.415 19.9424C11.9969 20.0581 12.6001 19.9987 13.1483 19.7716C13.6965 19.5446 14.165 19.1601 14.4947 18.6667C14.8243 18.1734 15.0002 17.5933 15.0002 17C15.0002 16.2044 14.6842 15.4413 14.1216 14.8787C13.559 14.3161 12.7959 14 12.0002 14ZM3.00024 11V23H21.0002V11M19.0002 19C18.4698 19 17.9611 19.2107 17.586 19.5858C17.211 19.9609 17.0002 20.4696 17.0002 21H7.00024C7.00024 20.4696 6.78953 19.9609 6.41446 19.5858C6.03939 19.2107 5.53068 19 5.00024 19V15C5.53068 15 6.03939 14.7893 6.41446 14.4142C6.78953 14.0391 7.00024 13.5304 7.00024 13H17.0002C17.0002 13.5304 17.211 14.0391 17.586 14.4142C17.9611 14.7893 18.4698 15 19.0002 15V19Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundIcon);
export default __webpack_public_path__ + "static/media/refund_icon.e9d5a7aa3ceb8af193a72fe9da277b18.svg";
export { ForwardRef as ReactComponent };